module.exports = __webpack_public_path__ + "img/fourday_ps_01.de0be5d6.jpg";